import { jsx as _jsx } from "react/jsx-runtime";
// text-box-trim is spec-restricted to the inline element directly wrapping
// the text — it silently no-ops on the flex containers every control uses.
// This primitive enforces that constraint at every callsite. Chrome 133+,
// Safari 18.2+; Firefox falls back to line-height: 1 (today's behavior
// across every comparable shipped DS).
const TRIM_STYLE = {
    display: 'inline-block',
    lineHeight: 1,
    textBox: 'trim-both cap alphabetic',
};
// For a label that can be user content (a group name): cut with an
// ellipsis instead of overflowing its control, which must also cap its own
// width (`max-width: 100%`). `overflow-x: clip`, not `hidden`, keeps the
// vertical axis visible — the trimmed box ends at cap height, so clipping
// it vertically would cut off descenders and accents.
const TRUNCATE_STYLE = {
    minWidth: 0,
    overflowX: 'clip',
    textOverflow: 'ellipsis',
};
export function TextTrim({ children, style, truncate = false, ref, ...rest }) {
    return (_jsx("span", { ref: ref, ...rest, style: { ...TRIM_STYLE, ...(truncate ? TRUNCATE_STYLE : undefined), ...style }, children: children }));
}
//# sourceMappingURL=text-trim.js.map